__turbopack_context__.v({
  "center": "AudioPlayer-module__JtFJDW__center",
  "composer": "AudioPlayer-module__JtFJDW__composer",
  "controls": "AudioPlayer-module__JtFJDW__controls",
  "left": "AudioPlayer-module__JtFJDW__left",
  "playButton": "AudioPlayer-module__JtFJDW__playButton",
  "playerContainer": "AudioPlayer-module__JtFJDW__playerContainer",
  "progressBar": "AudioPlayer-module__JtFJDW__progressBar",
  "progressWrapper": "AudioPlayer-module__JtFJDW__progressWrapper",
  "repeatButton": "AudioPlayer-module__JtFJDW__repeatButton",
  "repeatDisabled": "AudioPlayer-module__JtFJDW__repeatDisabled",
  "repeatWrapper": "AudioPlayer-module__JtFJDW__repeatWrapper",
  "right": "AudioPlayer-module__JtFJDW__right",
  "shuffleButton": "AudioPlayer-module__JtFJDW__shuffleButton",
  "shuffleDisabled": "AudioPlayer-module__JtFJDW__shuffleDisabled",
  "shuffleWrapper": "AudioPlayer-module__JtFJDW__shuffleWrapper",
  "sideControl": "AudioPlayer-module__JtFJDW__sideControl",
  "skipButton": "AudioPlayer-module__JtFJDW__skipButton",
  "slider": "AudioPlayer-module__JtFJDW__slider",
  "time": "AudioPlayer-module__JtFJDW__time",
  "timerIcon": "AudioPlayer-module__JtFJDW__timerIcon",
  "timerIcon_active": "AudioPlayer-module__JtFJDW__timerIcon_active",
  "timerMenu": "AudioPlayer-module__JtFJDW__timerMenu",
  "timerWrapper": "AudioPlayer-module__JtFJDW__timerWrapper",
  "tooltip": "AudioPlayer-module__JtFJDW__tooltip",
  "top": "AudioPlayer-module__JtFJDW__top",
  "trackImage": "AudioPlayer-module__JtFJDW__trackImage",
  "trackInfo": "AudioPlayer-module__JtFJDW__trackInfo",
  "trackLine": "AudioPlayer-module__JtFJDW__trackLine",
  "trackTitle": "AudioPlayer-module__JtFJDW__trackTitle",
  "volume": "AudioPlayer-module__JtFJDW__volume",
  "volumeIcon": "AudioPlayer-module__JtFJDW__volumeIcon",
});
